<div class="gap-lg flex flex-col">
  @for (form of indicateursForm.controls; track $index; let idx = $index) {
    <app-form-item-indicateur
      [idx]="idx + 1"
      [form]="form"
      [indicesGroups]="indicesResultats()"
      [referentiel]="referentiel()"
      [indiceResultats]="indiceResultats()"
    />
  }
  @if (estCreation()) {
    <app-button-add-new (click)="addIndicateur()" label="Ajouter un indicateur de performance" />
  }
</div>
